import { ComboboxSelect } from '@chronosphereio/chrono-ui';
import { Group } from '@/dashboards/components/Builder';
import { useLabelNames } from '../promql-builder-apis';
import { useBuilderContext } from '../promql-builder-context';
import { Filter } from '../promql-builder-model';

type FilterLabelSelectorProps = {
  filter: Filter;
  onFilterChange: (filter: Filter) => void;
  isFirst?: boolean;
  /**
   * The ref for the button that opens the menu.
   */
  buttonRef?: React.RefObject<HTMLButtonElement>;
};

export function FilterLabelSelector({ filter, onFilterChange, isFirst, buttonRef }: FilterLabelSelectorProps) {
  const { metric } = useBuilderContext();

  // Options
  const { data: options, isLoading } = useLabelNames(metric);

  // Value
  const value = filter.label || null;

  return (
    <ComboboxSelect
      isLoading={isLoading}
      value={value}
      renderValue={
        <Group.Button ref={buttonRef} isFirst={isFirst} isPlaceholder={!value}>
          {value ?? 'Label'}
        </Group.Button>
      }
      searchPlaceholder={'Search labels'}
      options={options}
      onSelect={(option) => {
        if (!option) {
          onFilterChange({ ...filter, label: '' });
        } else {
          onFilterChange({ ...filter, label: option });
        }
      }}
    />
  );
}
